// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"9d2e530c","453":"8701dc61"}[chunkId] + ".chunk.js";
};